import { f as fetchCartData, s as sendAddToCart } from "./cart-DXzKAPAO.js";
class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this._productComponent = null;
    this._variantSelectors = null;
    this._selectedVariantInput = null;
    this.soldOutToggles = null;
    this.atcButton = null;
    this.soldOutButton = null;
    this.bisButton = null;
    this.bisPopup = null;
    this.maxQuantityButton = null;
  }
  static get observedAttributes() {
    return ["product"];
  }
  connectedCallback() {
    this.cacheHTMLElements();
    this.attachEventListeners();
    this.checkMaxQuantityOnLoad();
  }
  cacheHTMLElements() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this._productComponent = document.querySelector("uwp-product");
    this._selectedVariantInput = this.querySelector(
      "[data-variant-input]"
    );
    if (window.themeVars.booleans.product.beer_box === false) {
      this._variantSelectors = this.querySelectorAll(
        "[data-variant-select]"
      );
    }
    this.soldOutToggles = [
      ...this.querySelectorAll("[data-sold-out-toggle")
    ];
    this.atcButton = ((_a = this._productComponent) == null ? void 0 : _a.querySelector("#atcButton")) || ((_b = this._productComponent) == null ? void 0 : _b.querySelector(
      "#multipleAtcButton"
    ));
    this.soldOutButton = (_c = this._productComponent) == null ? void 0 : _c.querySelector(
      "[data-sold-out-button]"
    );
    this.bisButton = (_d = this._productComponent) == null ? void 0 : _d.querySelector(
      "[data-bis-trigger]"
    );
    this.bisPopup = document.querySelector(
      `uwp-product-notify-me[data-product-id="${(_e = this.bisButton) == null ? void 0 : _e.getAttribute("data-product")}"]`
    );
    if (!((_f = this._productComponent) == null ? void 0 : _f.querySelector("[data-max-quantity-button]"))) {
      const maxBtn = document.createElement("button");
      maxBtn.type = "button";
      maxBtn.className = "product__preorder-button product__max-quantity-button btn btn-white";
      maxBtn.setAttribute("data-max-quantity-button", "");
      maxBtn.disabled = true;
      maxBtn.style.border = "1px solid #000";
      maxBtn.style.color = "#000";
      maxBtn.innerHTML = "<span>You've reached the max quantity</span>";
      this.maxQuantityButton = maxBtn;
      const productButtonWrapper = (_g = this._productComponent) == null ? void 0 : _g.querySelector(
        ".product__button__wrapper"
      );
      if (productButtonWrapper && this.atcButton) {
        productButtonWrapper.appendChild(this.maxQuantityButton);
      }
    } else {
      this.maxQuantityButton = (_h = this._productComponent) == null ? void 0 : _h.querySelector(
        "[data-max-quantity-button]"
      );
      if (this.maxQuantityButton) {
        this.maxQuantityButton.style.border = "1px solid #000";
        this.maxQuantityButton.style.color = "#000";
      }
    }
  }
  attachEventListeners() {
    var _a, _b, _c;
    const atcButtons = document.querySelectorAll("#atcButton");
    atcButtons.forEach((button) => {
      button.addEventListener("click", this.handleAtcButtonClick.bind(this));
    });
    if (this._variantSelectors) {
      this.selectVariant(Array.from(this._variantSelectors));
    }
    (_a = this.soldOutToggles) == null ? void 0 : _a.forEach((toggle) => {
      toggle.addEventListener("click", this.handleSoldOutToggle.bind(this));
    });
    (_b = this._productComponent) == null ? void 0 : _b.addEventListener(
      "quantityChanged",
      this.showATC.bind(this)
    );
    document.querySelectorAll(".product-swatches__quantity").forEach((quantitySelector) => {
      quantitySelector.addEventListener("click", () => {
        if (quantitySelector.classList.contains(
          "product-swatches__form-group--sold-out"
        ) === false) {
          this.showATC();
        }
      });
    });
    if (!this._productComponent)
      return;
    (_c = this.bisButton) == null ? void 0 : _c.addEventListener("click", () => {
      var _a2;
      (_a2 = this.bisPopup) == null ? void 0 : _a2.setAttribute("is-visible", "true");
    });
    document.querySelectorAll("[data-qty-input]").forEach((input) => {
      input.addEventListener("change", (event) => {
        if (event.type === "initialLoad")
          return;
        this.checkMaxQuantity();
      });
    });
  }
  async checkMaxQuantity(shouldResetInputs = true) {
    var _a, _b, _c, _d, _e;
    const productData = JSON.parse(
      ((_a = this._productComponent) == null ? void 0 : _a.getAttribute("product")) || "{}"
    );
    const isProductAvailable = productData.available !== false;
    const inputs = document.querySelectorAll("[data-qty-input]");
    let allMaxedOut = true;
    for (const input of inputs) {
      const max = parseInt(input.max, 10);
      const variantId = input.getAttribute("data-id");
      if (!variantId)
        continue;
      if (max <= 0 && shouldResetInputs) {
        input.value = "0";
      }
      if (max > 0) {
        allMaxedOut = false;
      }
    }
    if (!isProductAvailable) {
      (_b = this.maxQuantityButton) == null ? void 0 : _b.classList.add("hidden");
      return;
    }
    if (allMaxedOut && inputs.length > 0) {
      (_c = this.atcButton) == null ? void 0 : _c.classList.add("hidden");
      (_d = this.maxQuantityButton) == null ? void 0 : _d.classList.remove("hidden");
    } else {
      (_e = this.maxQuantityButton) == null ? void 0 : _e.classList.add("hidden");
    }
  }
  showATC() {
    var _a, _b, _c, _d;
    const product = JSON.parse(
      ((_a = this._productComponent) == null ? void 0 : _a.getAttribute("product")) || "{}"
    );
    const selectedSoldOut = (_b = this.soldOutToggles) == null ? void 0 : _b.find(
      (toggle) => toggle.classList.contains("is-selected")
    );
    selectedSoldOut == null ? void 0 : selectedSoldOut.classList.remove("is-selected");
    if (!product.available) {
      return;
    }
    this.checkMaxQuantity(false);
    if (!((_c = this.maxQuantityButton) == null ? void 0 : _c.classList.contains("hidden"))) {
      return;
    }
    (_d = this.atcButton) == null ? void 0 : _d.classList.remove("hidden");
    [this.soldOutButton, this.bisButton].forEach(
      (button) => button == null ? void 0 : button.classList.add("hidden")
    );
  }
  handleSoldOutToggle(event) {
    var _a, _b, _c, _d, _e, _f;
    event.preventDefault();
    event.stopPropagation();
    const target = event.target.closest("[data-sold-out-toggle]") || event.target;
    (_a = this.soldOutToggles) == null ? void 0 : _a.forEach((toggle) => {
      if (toggle === target && toggle.classList.contains("is-selected")) {
        toggle.classList.remove("is-selected");
        return;
      }
      toggle.classList.toggle("is-selected", toggle === target);
    });
    const isSelected = target.classList.contains("is-selected");
    if (!isSelected) {
      this.showATC();
      return;
    }
    const bisEnabled = target.hasAttribute("data-show-bis");
    (_b = this.atcButton) == null ? void 0 : _b.classList.toggle("hidden", isSelected);
    (_c = this.maxQuantityButton) == null ? void 0 : _c.classList.add("hidden");
    (_d = this.soldOutButton) == null ? void 0 : _d.classList.toggle("hidden", isSelected && bisEnabled);
    if (!this.bisButton || !this.bisPopup) {
      return;
    }
    (_e = this.bisPopup) == null ? void 0 : _e.setAttribute(
      "variant-id",
      target.getAttribute("data-variant-id") || ""
    );
    (_f = this.bisButton) == null ? void 0 : _f.classList.toggle("hidden", isSelected && !bisEnabled);
  }
  async handleAtcButtonClick() {
    const cartData = await fetchCartData();
    const productForm = this.closest(".ProductForm");
    if (!productForm) {
      return;
    }
    const variantInput = productForm == null ? void 0 : productForm.querySelector(
      '.product-swatches__form-group--variant-select.selected [name="product_variant"]'
    );
    if (variantInput) {
      const variantId = variantInput.value;
      const cartItem = cartData.items.find(
        (item2) => item2.variant_id.toString() === variantId
      );
      const maxQuantity = parseInt(
        variantInput.getAttribute("data-max-quantity") || "99",
        10
      );
      const cartQuantity = cartItem ? cartItem.quantity : 0;
      if (cartQuantity >= maxQuantity) {
        const errorMessage = document.createElement("span");
        errorMessage.classList.add("product-swatches__max-qty-error");
        errorMessage.innerHTML = "You've reached the max quantity";
        errorMessage.style.display = "block";
        errorMessage.style.color = "red";
        errorMessage.style.fontWeight = "bold";
        errorMessage.style.marginTop = "10px";
        errorMessage.style.marginBottom = "10px";
        errorMessage.style.position = "relative";
        errorMessage.style.zIndex = "10";
        const swatchesContainer = productForm.querySelector(
          ".product-swatches__form-group-wrapper"
        );
        if (swatchesContainer) {
          const existingError = productForm.querySelector(
            ".product-swatches__max-qty-error"
          );
          if (existingError) {
            existingError.remove();
          }
          swatchesContainer.insertAdjacentElement("afterend", errorMessage);
          setTimeout(() => {
            errorMessage.remove();
          }, 3e3);
        }
        return;
      }
      const item = {
        id: variantId || "",
        quantity: 1,
        properties: {},
        selling_plan: ""
      };
      const pfandValue = variantInput.getAttribute("data-pfand");
      if (pfandValue) {
        item.properties["Pfand"] = pfandValue;
      }
      sendAddToCart([item]);
      return;
    }
    const inputs = productForm.querySelectorAll("[data-qty-input]");
    const items = [];
    let exceedsMaxQuantity = false;
    for (const input of inputs) {
      const quantity = parseInt(input.value, 10);
      if (quantity <= 0)
        continue;
      const variantId = input.getAttribute("data-id");
      if (!variantId)
        continue;
      const cartItem = cartData.items.find(
        (item) => item.variant_id.toString() === variantId
      );
      const originalMax = parseInt(input.max, 10);
      const cartQuantity = cartItem ? cartItem.quantity : 0;
      const totalQuantity = cartQuantity + quantity;
      if (totalQuantity > originalMax) {
        exceedsMaxQuantity = true;
        break;
      }
      const pfandValue = input.getAttribute("data-pfand");
      const properties = {};
      if (pfandValue) {
        properties["Pfand"] = pfandValue;
      }
      items.push({
        id: variantId,
        quantity,
        properties,
        selling_plan: ""
      });
    }
    if (exceedsMaxQuantity) {
      const errorMessage = document.createElement("span");
      errorMessage.classList.add("product-swatches__max-qty-error");
      errorMessage.innerHTML = "You've reached the max quantity";
      errorMessage.style.display = "block";
      errorMessage.style.color = "red";
      errorMessage.style.fontWeight = "bold";
      errorMessage.style.marginTop = "10px";
      errorMessage.style.marginBottom = "10px";
      errorMessage.style.position = "relative";
      errorMessage.style.zIndex = "10";
      const swatchesContainer = productForm.querySelector(
        ".product-swatches__form-group-wrapper"
      );
      if (swatchesContainer) {
        const existingError = productForm.querySelector(
          ".product-swatches__max-qty-error"
        );
        if (existingError) {
          existingError.remove();
        }
        swatchesContainer.insertAdjacentElement("afterend", errorMessage);
        setTimeout(() => {
          errorMessage.remove();
        }, 3e3);
      }
      return;
    }
    if (items.length > 0) {
      sendAddToCart(items);
    }
  }
  selectVariant(variantSelectors) {
    const atcButtonTotal = document.querySelector("[data-product-total]");
    variantSelectors.forEach((selector) => {
      const price = selector.querySelector("[data-price]");
      selector.addEventListener("click", () => {
        variantSelectors.forEach((s) => s.classList.remove("selected"));
        selector.classList.add("selected");
        if (this._selectedVariantInput) {
          const variantId = selector.getAttribute("data-variant-id") || "";
          this._selectedVariantInput.value = variantId;
          if (atcButtonTotal) {
            atcButtonTotal.innerHTML = `<span class="atc-breaker">|</span>${(price == null ? void 0 : price.innerHTML) || ""}`;
          }
        }
      });
    });
  }
  // New specialized method for initial load that only sets values to 0 when needed
  async checkMaxQuantityOnLoad() {
    const inputs = document.querySelectorAll("[data-qty-input]");
    for (const input of inputs) {
      const max = parseInt(input.max, 10);
      const variantId = input.getAttribute("data-id");
      if (!variantId)
        continue;
      if (max <= 0) {
        input.value = "0";
      }
    }
    this.checkMaxQuantity(false);
  }
}
customElements.define("uwp-product-swatches", ProductSwatches);
